import { render } from "./ModalTerm.vue?vue&type=template&id=6660a564"
import script from "./ModalTerm.vue?vue&type=script&lang=js"
export * from "./ModalTerm.vue?vue&type=script&lang=js"

import exportComponent from "D:\\htdocs\\cosmocoslab_live\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__